// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"594":"about","843":"teamwork"}[chunkId] || chunkId) + "." + {"216":"d0e3aaea","483":"3d5e0f8c","594":"5d89ef9e","843":"479abffb"}[chunkId] + ".css";
};